"use client";

import createSvgIcon from "./utils/createSvgIcon.mjs";
import { jsx as _jsx } from "react/jsx-runtime";
export default createSvgIcon([/*#__PURE__*/_jsx("path", {
  d: "M8 8H6v9h11v-2H8z"
}, "0"), /*#__PURE__*/_jsx("path", {
  d: "M22 3H10v10h12zm-2 8h-8V7h8zM4 12H2v9h11v-2H4z"
}, "1")], 'DynamicFeedSharp');